<template>
  <router-view/>
</template>

<script>
import {ref} from "vue";

export default {
  setup() {
    const categories = [
      {id: 5, image: '/img/پروتئین‌بار زیرو سوفیت- براونی ساشه.webp', title: 'زیرو پروتئین‌بارها'},
      {id: 2, image: '/img/فروت‌بار زردآلو- ساشه.webp', title: 'فروت‌بار'},
      {id: 3, image: '/img/پاوچ موسلی نارگیل و شکلات تلخ.webp', title: 'موسلی ‌پاوچ'},
      {id: 4, image: '/img/موسلی باکس پسته و گل محمدی.webp', title: 'موسلی باکس'},
      {id: 7, image: '/img/کیسه پروتئین‌بار سوفیت لقمه.webp', title: 'میکس لقمه پروتئین‌بار'},
      {id: 8, image: '/img/کیسه انرژی‌بار لقمه.webp', title: 'میکس لقمه گرانولابار'},
      {id: 6, image: '/img/پروتئین‌بار سوفیت قهوه.webp', title: 'پروتئین‌بارها'},
      {id: 1, image: '/img/انرژی‌بار بادام زمینی- ساشه.webp', title: 'گرانولابار'},

    ];
    const pros = [

      {id:1,cat_id: 1, image: '/img/انرژی‌بار بادام زمینی- ساشه.webp', title: 'گرانولابار بادام زمینی',
        subTitle: 'با کره بادام زمینی و مغز دانه‌های خوراکی',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 12% پروتئین',
        weight: 45,
        ingredients: 'جو پرک، جو دوسر پرک، عسل، کره بادام زمینی، غلات فرآوری شده گندم و ذرت، بادام زمینی، روغن کنجد، دارچین، نمک تصفیه شده خوراکی',
        nutritional_value: {
          energy: '197.1', carbohydrate: '28.12', protein: '5.53', fat: '7.87', fiber: '1'
        }
      },
      {id:2,cat_id: 1, image: '/img/انرژی‌بار دانه و کشمش- ساشه.webp', title: 'گرانولابار دانه و کشمش',
        subTitle: 'با کشمش و مغز دانه‌های خوراکی',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 10% پروتئین',
        weight: 35,
        ingredients: 'جو پرک، جو دوسر پرک، خرما، عسل، کشمش، مغز تخم آفتابگردان، مغز تخم کدو، غلات فرآوری شده گندم و ذرت، طعم‌دهنده طبیعی مجاز خوراکی، روغن کنجد، روغن نارگیل',
        nutritional_value: {
          energy: '122.6', carbohydrate: '23.71', protein: '3.5', fat: '1.72', fiber: '1.96'
        }
      },

      {id:3,cat_id: 1, image: '/img/انرژی‌بار دانه چیا- ساشه.webp', title: 'گرانولابار دانه چیا',
        subTitle: 'با دانه چیا و مغز دانه‌های خوراکی',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 10% پروتئین',
        weight: 35,
        ingredients: 'جو پرک، جو دوسر پرک، خرما، عسل، دانه چیا، غلات فرآوری شده گندم و ذرت، کنجد، فندق، مغز تخم آفتابگردان، روغن نارگیل، هل، زنجبیل، طعم‌دهنده مشابه طبیعی لیمو، نمک تصفیه شده خوراکی',
        nutritional_value: {
          energy: '130.83', carbohydrate: '22.85', protein: '3.46', fat: '3.19', fiber: '2.13'
        }
      },
      {id:4,cat_id: 1, image: '/img/انرژی‌بار نارگیل- ساشه.webp', title: 'گرانولابار نارگیل',
        subTitle: 'با نارگیل و مغز دانه‌های خوراکی',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 10% پروتئین',
        weight: 35,
        ingredients: 'جو پرک، جو دوسر پرک، عسل، پودر نارگیل، غلات فرآوری شده گندم و ذرت، مغز تخم آفتابگردان، کنجد، فندق، روغن نارگیل، روغن کنجد، نمک تصفیه شده خوراکی',
        nutritional_value: {
          energy: '147.14', carbohydrate: '21.24', protein: '3.29', fat: '6.14', fiber: '1.92'
        }
      },
      {id:5,cat_id: 1, image: '/img/انرژی‌بار کرنبری- ساشه.webp', title: 'گرانولابار کرنبری',
        subTitle: 'با کرنبری و مغز دانه‌های خوراکی',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 9% پروتئین',
        weight: 35,
        ingredients: 'جو پرک، جو دو سر پرک، عسل، کرنبری، غلات فرآوری شده گندم و ذرت، خرما، بادام، ارده، روغن نارگیل، تمشک، نمک تصفیه شده خوراکی',
        nutritional_value: {
          energy: '137.9', carbohydrate: '26.4', protein: '3', fat: '2.5', fiber: '1'
        }
      },

      {id:6,cat_id: 8, image: '/img/کیسه انرژی‌بار لقمه.webp', title: 'گرانولابار لقمه بسته 15 عددی',

      },
      {id:7,cat_id: 8, image: '/img/انرژی‌بار لقمه بادام زمینی- ساشه.webp', title: 'گرانولابار لقمه بادام زمینی',
        subTitle: 'با روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'بار فشرده جوپرک با کره بادام‌زمینی',
        weight: 100,
        ingredients: '',
        nutritional_value: {
          Calcium: '0.033',  protein: '4.59', addedSugar: '2.37', sugar: '2.66', fibre: '0.75',
          carbohydrate: '4.53', sodium: '0.012', cholesterol: '3.93',transFattyAcids:'0.01',saturatedFattyAcids:'0.82', fat: '1.42'
        }
      },
      {id:8,cat_id: 8, image: '/img/انرژی‌بار لقمه دانه و کشمش- ساشه.webp', title: 'گرانولابار لقمه دانه و کشمش',
        subTitle: 'با روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'بار فشرده جوپرک با کشمش و مغزدانه‌های خوراکی',
        weight: 100,
        ingredients: '',
        nutritional_value: {
          Calcium: '0.033',  protein: '4.59', addedSugar: '2.37', sugar: '2.66', fibre: '0.75',
          carbohydrate: '4.53', sodium: '0.012', cholesterol: '3.93',transFattyAcids:'0.01',saturatedFattyAcids:'0.82', fat: '1.42'
        }
      },
      {id:9,cat_id: 8, image: '/img/انرژی‌بار لقمه دانه چیا- ساشه.webp', title: 'گرانولابار لقمه دانه چیا',
        subTitle: 'با روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'بار فشرده جوپرک با دانه چیا',
        weight: 100,
        ingredients: '',
        nutritional_value: {
          Calcium: '0.033',  protein: '4.59', addedSugar: '2.37', sugar: '2.66', fibre: '0.75',
          carbohydrate: '4.53', sodium: '0.012', cholesterol: '3.93',transFattyAcids:'0.01',saturatedFattyAcids:'0.82', fat: '1.42'
        }
      },
      {id:10,cat_id: 8, image: '/img/انرژی‌بار لقمه نارگیل- ساشه.webp', title: 'گرانولابار لقمه نارگیل',
        subTitle: 'با روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'بار فشرده جوپرک با نارگیل',
        weight: 100,
        ingredients: '',
        nutritional_value: {
          Calcium: '0.033',  protein: '4.59', addedSugar: '2.37', sugar: '2.66', fibre: '0.75',
          carbohydrate: '4.53', sodium: '0.012', cholesterol: '3.93',transFattyAcids:'0.01',saturatedFattyAcids:'0.82', fat: '1.42'
        }
      },
      {id:11,cat_id: 8, image: '/img/انرژی‌بار لقمه کرنبری- ساشه.webp', title: 'گرانولابار لقمه کرنبری',
        subTitle: 'با روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'بار فشرده جوپرک با کرنبری',
        weight: 100,
        ingredients: '',
        nutritional_value: {
          Calcium: '0.033',  protein: '4.59', addedSugar: '2.37', sugar: '2.66', fibre: '0.75',
          carbohydrate: '4.53', sodium: '0.012', cholesterol: '3.93',transFattyAcids:'0.01',saturatedFattyAcids:'0.82', fat: '1.42'
        }
      },


      {id:12,cat_id: 2, image: '/img/فروت‌بار آلبالو- ساشه.webp', title: 'فروت‌بار آلبالو',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:18,cat_id: 2, image: '/img/باکس فروت‌بار آلبالو.webp', title: 'باکس فروت‌بار آلبالو',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:13,cat_id: 2, image: '/img/فروت‌بار انار- ساشه.webp', title: 'فروت‌بار انار',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:19,cat_id: 2, image: '/img/باکس فروت‌بار انار.webp', title: 'باکس فروت‌بار انار',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},

      {id:14,cat_id: 2, image: '/img/فروت‌بار زردآلو- ساشه.webp', title: 'فروت‌بار زردآلو',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:20,cat_id: 2, image: '/img/باکس فروت‌بار زردآلو.webp', title: 'باکس فروت‌بار زردآلو',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:15,cat_id: 2, image: '/img/فروت‌بار موز و رزبری- ساشه.webp', title: 'فروت‌بار موز و رزبری',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:21,cat_id: 2, image: '/img/باکس فروت‌بار موز و رزبری.webp', title: 'باکس فروت‌بار موز و رزبری',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:16,cat_id: 2, image: '/img/فروت‌بار میکس بری- ساشه.webp', title: 'فروت‌بار میکس بری',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:22,cat_id: 2, image: '/img/باکس فروت‌بار میکس بری.webp', title: 'باکس فروت‌بار میکس بری',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:17,cat_id: 2, image: '/img/فروت‌بار هلو و انجیر- ساشه.webp', title: 'فروت‌بار هلو و انجیر',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},
      {id:23,cat_id: 2, image: '/img/باکس فروت‌بار هلو و انجیر.webp', title: 'باکس فروت‌بار هلو و انجیر',
        subTitle: 'اسنکی بر پایه میوه با تکه‌های میوه',
        sugar: 'بدون شکر و قند افزوده بدون نگهدارنده',
        contains:'حاوی خرما'},


      {id:24,cat_id: 3, image: '/img/پاوچ موسلی انار و پاپریکا.webp', title: 'موسلی انار و پاپریکا',
        subTitle: 'با انار و پاپریکا',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی آنتی‌اکسیدان و فیبر طبیعی',
        weight: 350,
        ingredients: 'جوپرک، جو دوسرپرک، رب انار، مغزتخمه هندوانه، بادام‌زمینی، دانه سویا و پودر پاپریکا',
        nutritional_value: {
          energy: '97.25', carbohydrate: '', protein: '', fat: '0.6', fiber: '4.5'
        }
      },
      {id:25,cat_id: 3, image: '/img/پاوچ موسلی بادام زمینی.webp', title: 'موسلی بادام زمینی',
        subTitle: 'با کره بادام زمینی',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی فیبر طبیعی',
        weight: 350,
        ingredients: 'جو پرک، جو دو سر پرک، عسل، کره بادام زمینی، سویا، کینوآ، پروتئین تلغیظ شده آب پنیر، بادام زمینی، شکلات تلخ',
        nutritional_value: {
          energy: '122.6', carbohydrate: '17.7', protein: '6.2', fat: '3.3', fiber: '1.8'
        }
      },
      {id:26,cat_id: 3, image: '/img/پاوچ موسلی زردآلو.webp', title: 'موسلی زردآلو',
        subTitle: 'با زردآلو و کشمش',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی آهن، منیزیم و فیبر طبیعی',
        weight: 350,
        ingredients: 'جو پرک، عسل، زردآلو، فندق، کشمش',
        nutritional_value: {
          energy: '111.8', carbohydrate: '22.9', protein: '2.25', fat: '1.39', fiber: '2.1'
        }
      },
      {id:27,cat_id: 3, image: '/img/پاوچ موسلی سیب و دارچین.webp', title: 'موسلی سیب و دارچین',
        subTitle: 'با سیب و دارچین',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی روی، منیزیم و فیبر طبیعی',
        weight: 350,
        ingredients: 'جو پرک، عسل، سیب خشک، بادام، مویز، تخم کتان، مغز تخم آفتابگردان، دارچین',
        nutritional_value: {
          energy: '117.4', carbohydrate: '22', protein: '2.93', fat: '2.2', fiber: '2.17'
        }
      },
      {id:28,cat_id: 3, image: '/img/پاوچ موسلی نارگیل و شکلات تلخ.webp', title: 'موسلی نارگیل و شکلات تلخ',
        subTitle: 'با نارگیل و شکلات تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی آهن، منیزیم و فیبر طبیعی',
        weight: 350,
        ingredients: 'جو پرک، جو دو سر پرک، عسل، نارگیل، شکلات تلخ، بادام، تخم کدو، دانه چیا',
        nutritional_value: {
          energy: '131.6', carbohydrate: '19.5', protein: '3.33', fat: '5.04', fiber: '2.6'
        }
      },
      {id:29,cat_id: 3, image: '/img/پاوچ موسلی پسته و گل محمدی.webp', title: 'موسلی پسته و گل محمدی' ,
        subTitle: 'با پسته و گل‌سرخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی آنتی‌اکسیدان و فیبر طبیعی',
        weight: 350,
        ingredients: 'جوپرک، جو دوسرپرک، شیره انگور، پسته و گل سرخ',
        nutritional_value: {
          energy: '91.7', carbohydrate: '', protein: '', fat: '0.6', fiber: '4.5'
        }
      },
      {id:30,cat_id: 3, image: '/img/پاوچ موسلی کرنبری.webp', title: 'موسلی کرنبری',
        subTitle: 'با کرنبری',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی آنتی‌اکسیدان و فیبر طبیعی',
        weight: 350,
        ingredients: 'جو پرک، عسل، کرنبری، بادام، کشمش',
        nutritional_value: {
          energy: '113.8', carbohydrate: '23.1', protein: '2.6', fat: '1.4', fiber: '2'
        }
      },

      {id:31,cat_id: 4, image: '/img/موسلی باکس انار و پاپریکا.webp', title: 'موسلی باکس انار و پاپریکا' },
      {id:32,cat_id: 4, image: '/img/موسلی باکس بادام زمینی.webp', title: 'موسلی باکس بادام زمینی' },
      {id:33,cat_id: 4, image: '/img/موسلی باکس زردآلو.webp', title: 'موسلی باکس زردآلو' },
      {id:34,cat_id: 4, image: '/img/موسلی باکس سیب و دارچین.webp', title: 'موسلی باکس سیب و دارچین' },
      {id:35,cat_id: 4, image: '/img/موسلی باکس نارگیل و شکلات تلخ.webp', title: 'موسلی باکس نارگیل و شکلات تلخ' },
      {id:36,cat_id: 4, image: '/img/موسلی باکس پسته و گل محمدی.webp', title: 'موسلی باکس پسته و گل محمدی' },
      {id:37,cat_id: 4, image: '/img/موسلی باکس کرنبری.webp', title: 'موسلی باکس کرنبری' },


      {id:38,cat_id: 6, image: '/img/پروتئین‌بار سوفیت فندق.webp', title: 'پروتئین‌بار سوفیت فندق',
        subTitle: 'با روکش شکلات تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 30% پروتیئن وی',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا، پروتئین تلغیظ شده شیر، دانه سویا، پروتئین تلغیظ شده آب پنیر، شاه دانه)، عسل، روغن کنجد، کره بادام درختی، فرآورده حجیم شده گندم، پودر کاکائو، لسیتین سویا، نمک تصفیه شده خوراکی، طعم دهنده مشابه فندق، زانتان، آب، فرآوره کاکائویی تلخ',
        nutritional_value: {
          energy: '151.65', carbohydrate: '13.60', protein: '13.83', fat: '4.3', fiber: '2.25'
        }
      },
      {id:39,cat_id: 6, image: '/img/پروتئین‌بار سوفیت قهوه.webp', title: 'پروتئین‌بار سوفیت قهوه' },
      {id:40,cat_id: 6, image: '/img/پروتئین‌بار سوفیت موز.webp', title: 'پروتئین‌بار سوفیت موز',
        subTitle: 'با روکش شکلات تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 30% پروتیئن وی',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا، پروتئین تلغیظ شده شیر، دانه سویا، پروتئین تلغیظ شده آب پنیر، شاه دانه)، عسل، روغن کنجد، کره بادام درختی، فرآورده حجیم شده گندم، پودر کاکائو، لسیتین سویا، نمک تصفیه شده خوراکی، طعم دهنده مشابه موز، زانتان، آب، فرآوره کاکائویی تلخ',
        nutritional_value: {
          energy: '151.65', carbohydrate: '13.60', protein: '13.83', fat: '4.3', fiber: '2.25'
        }
      },
      {id:41,cat_id: 6, image: '/img/پروتئین‌بار سوفیت پرتقال.webp', title: 'پروتئین‌بار سوفیت پرتقال',
        subTitle: 'با روکش شکلات تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 30% پروتیئن وی',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا، پروتئین تلغیظ شده شیر، دانه سویا، پروتئین تلغیظ شده آب پنیر، شاه دانه)، عسل، روغن کنجد، کره بادام درختی، فرآورده حجیم شده گندم، پودر کاکائو، لسیتین سویا، نمک تصفیه شده خوراکی، طعم دهنده مشابه پرتقالی، زانتان، آب، فرآوره کاکائویی تلخ',
        nutritional_value: {
          energy: '151.65', carbohydrate: '13.60', protein: '13.83', fat: '4.3', fiber: '2.25'
        }
      },
      {id:42,cat_id: 6, image: '/img/پروتئین‌بار سوفیت کارامل.webp', title: 'پروتئین‌بار سوفیت کارامل',
        subTitle: 'با روکش شکلات تلخ',
        sugar: 'بدون شکر افزوده، فقط با عسل طبیعی',
        contains: 'حاوی 30% پروتیئن وی',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا، پروتئین تلغیظ شده شیر، دانه سویا، پروتئین تلغیظ شده آب پنیر، شاه دانه)، عسل، روغن کنجد، کره بادام درختی، فرآورده حجیم شده گندم، پودر کاکائو، لسیتین سویا، نمک تصفیه شده خوراکی، طعم دهنده مشابه کارامل، زانتان، آب، فرآوره کاکائویی تلخ',
        nutritional_value: {
          energy: '151.65', carbohydrate: '13.60', protein: '13.83', fat: '4.3', fiber: '2.25'
        }
      },
      {id:43,cat_id: 7, image: '/img/کیسه پروتئین‌بار سوفیت لقمه.webp', title: 'پروتئین‌بار لقمه سوفیت بسته 12 عددی' },
      {id:44,cat_id: 7, image: '/img/پروتئین‌بار لقمه سوفیت فندق.webp', title: 'پروتئین‌بار لقمه سوفیت فندق' },
      {id:45,cat_id: 7, image: '/img/پروتئین‌بار لقمه سوفیت قهوه.webp', title: 'پروتئین‌بار لقمه سوفیت قهوه' },
      {id:46,cat_id: 7, image: '/img/پروتئین‌بار لقمه سوفیت موز.webp', title: 'پروتئین‌بار لقمه سوفیت موز' },
      {id:47,cat_id: 7, image: '/img/پروتئین‌بار لقمه سوفیت پرتقال.webp', title: 'پروتئین‌بار لقمه سوفیت پرتقال' },
      {id:48,cat_id: 7, image: '/img/پروتئین‌بار لقمه سوفیت کارامل.webp', title: 'پروتئین‌بار لقمه سوفیت کارامل' },

      {id:49,cat_id: 5, image: '/img/پروتئین‌بار زیرو سوفیت- بادام زمینی ساشه.webp', title: 'پروتئین‌بار زیرو سوفیت بادام زمینی',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
        contains: 'حاوی 9 آمینواسید ضروری',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا غیر تراریخته، پروتئین تغلیط شده شیر، پروتئین تغلیظ شده آب پنیر)، روغن کنجد هیدوژنه نشده، بادام زمینی، کره بادام زمینی، پودر کاکائو، لسیتین سویا غیر تراریخته، شیرین‌کننده استویا (سوربیتول، مالتو دکسترین، اینولین، ایزومالت، استویوزید A)، صمغ زانتان، نمک تصفیه‌شده خوراکی، آب آشامیدنی، فرآورده کاکائویی تلخ.',
        nutritional_value: {
          energy: '198', transFattyAcids: '0.00', salt: '0.02', fat: '11.6', fiber: '0.0'
        }
      },
      {id:54,cat_id: 5, image: '/img/باکس پروتئین‌بار زیرو سوفیت- بادام زمینی.webp', title: 'پروتئین‌بار زیرو سوفیت بادام زمینی',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',

      },
      {id:50,cat_id: 5, image: '/img/پروتئین‌بار زیرو سوفیت- براونی ساشه.webp', title: 'پروتئین‌بار زیرو سوفیت براونی',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
      },
      {id:55,cat_id: 5, image: '/img/باکس پروتئین‌بار زیرو سوفیت- براونی.webp', title: 'پروتئین‌بار زیرو سوفیت براونی',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',

      },
      {id:51,cat_id: 5, image: '/img/پروتئین‌بار زیرو سوفیت- سیب و دارچین ساشه.webp', title: 'پروتئین‌بار زیرو سوفیت سیب و دارچین',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
        contains: 'حاوی 9 آمینواسید ضروری',
        weight: 45,
        ingredients:'مجموعه پروتئینی (پروتئین ایزوله سویا غیر تراریخته، پروتئین تغلیط شده شیر، پروتئین تغلیظ شده آب پنیر)، روغن کنجد هیدوژنه نشده، سیب خشک، پودر کاکائو، دارچین، لسیتین سویا غیر تراریخته، شیرین‌کننده استویا (سوربیتول، مالتو دکسترین، اینولین، ایزومالت، استویوزید A)، صمغ زانتان، نمک تصفیه‌شده خوراکی، آب آشامیدنی، فرآورده کاکائویی تلخ',
        nutritional_value: {
          energy: '188.1', transFattyAcids: '0.00', salt: '0.03', fat: '9.27', fiber: '0.0'
        }
      },
      {id:56,cat_id: 5, image: '/img/باکس پروتئین‌بار زیرو سوفیت- سیب و دارچین.webp', title: 'پروتئین‌بار زیرو سوفیت سیب و دارچین',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
        contains: 'حاوی 9 آمینواسید ضروری',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا غیر تراریخته، پروتئین تغلیط شده شیر، پروتئین تغلیظ شده آب پنیر)، روغن کنجد هیدوژنه نشده، بادام زمینی، کره بادام زمینی، پودر کاکائو، لسیتین سویا غیر تراریخته، شیرین‌کننده استویا (سوربیتول، مالتو دکسترین، اینولین، ایزومالت، استویوزید A)، صمغ زانتان، نمک تصفیه‌شده خوراکی، آب آشامیدنی، فرآورده کاکائویی تلخ.',
        nutritional_value: {
          energy: '198', transFattyAcids: '0.00', salt: '0.02', fat: '11.6', fiber: '0.0'
        }      },

      {id:52,cat_id: 5, image: '/img/پروتئین‌بار زیرو سوفیت- موز و توت‌فرنگی ساشه.webp', title: 'پروتئین‌بار زیرو سوفیت موز و توت‌فرنگی',
        subTitle: 'بدون شکر با طعم دهنده مشابه طبیعی توت فرنگی و موز ، با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
        contains: 'حاوی 9 آمینواسید ضروری',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا غیر تراریخته، پروتئین تغلیط شده شیر، پروتئین تغلیظ شده آب پنیر)، روغن کنجد هیدوژنه نشده، طعم دهنده مشابه طبیعی توت فرنگی و موز، پودر کاکائو، لسیتین سویا غیر تراریخته، شیرین‌کننده استویا (سوربیتول، مالتو دکسترین، اینولین، ایزومالت، استویوزید A)، زانتان، نمک تصفیه‌شده خوراکی، آب آشامیدنی، فرآورده کاکائویی تلخ',
        nutritional_value: {
          energy: '194.85', transFattyAcids: '0.00', salt: '0.05', fat: '10.53', fiber: '0.0'
        }
      },
      {id:57,cat_id: 5, image: '/img/باکس پروتئین‌بار زیرو سوفیت موز و توت‌فرنگی.webp', title: 'پروتئین‌بار زیرو سوفیت موز و توت‌فرنگی',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
        contains: 'حاوی 9 آمینواسید ضروری',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا غیر تراریخته، پروتئین تغلیط شده شیر، پروتئین تغلیظ شده آب پنیر)، روغن کنجد هیدوژنه نشده، بادام زمینی، کره بادام زمینی، پودر کاکائو، لسیتین سویا غیر تراریخته، شیرین‌کننده استویا (سوربیتول، مالتو دکسترین، اینولین، ایزومالت، استویوزید A)، صمغ زانتان، نمک تصفیه‌شده خوراکی، آب آشامیدنی، فرآورده کاکائویی تلخ.',
        nutritional_value: {
          energy: '198', transFattyAcids: '0.00', salt: '0.02', fat: '11.6', fiber: '0.0'
        }      },
      {id:53,cat_id: 5, image: '/img/پروتئین‌بار زیرو سوفیت- کارامل نمکی ساشه.webp', title: 'پروتئین‌بار زیرو سوفیت کارامل نمکی',
        subTitle: 'با طعم دهنده مشابه طبیعی کارامل نمکی، با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
        contains: 'حاوی 9 آمینواسید ضروری',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا غیر تراریخته، پروتئین تغلیط شده شیر، پروتئین تغلیظ شده آب پنیر)، روغن کنجد هیدوژنه نشده، طعم دهنده مشابه طبیعی کارامل، پودر کاکائو، لسیتین سویا غیر تراریخته، شیرین‌کننده استویا (سوربیتول، مالتو دکسترین، اینولین، ایزومالت، استویوزید A)، صمغ زانتان، نمک تصفیه‌شده خوراکی، آب آشامیدنی، فرآورده کاکائویی تلخ',
        nutritional_value: {
          energy: '194.85', transFattyAcids: '0.00', salt: '0.05', fat: '10.53', fiber: '0.0'
        }
      },
      {id:58,cat_id: 5, image: '/img/باکس پروتئین‌بار زیرو سوفیت- کارامل نمکی.webp', title: 'پروتئین‌بار زیرو سوفیت کارامل نمکی',
        subTitle: 'بدون شکر با شیرین‌کننده استویا و روکش فرآورده کاکائویی تلخ',
        sugar: 'بدون افزودنی، بدون مواد نگهدارنده',
        contains: 'حاوی 9 آمینواسید ضروری',
        weight: 45,
        ingredients: 'مجموعه پروتئینی (پروتئین ایزوله سویا غیر تراریخته، پروتئین تغلیط شده شیر، پروتئین تغلیظ شده آب پنیر)، روغن کنجد هیدوژنه نشده، بادام زمینی، کره بادام زمینی، پودر کاکائو، لسیتین سویا غیر تراریخته، شیرین‌کننده استویا (سوربیتول، مالتو دکسترین، اینولین، ایزومالت، استویوزید A)، صمغ زانتان، نمک تصفیه‌شده خوراکی، آب آشامیدنی، فرآورده کاکائویی تلخ.',
        nutritional_value: {
          energy: '198', transFattyAcids: '0.00', salt: '0.02', fat: '11.6', fiber: '0.0'
        }      },

    ];

    return {

      pros, categories
    }
  }


}
</script>